import React from 'react'
import HowItWorks from "../../components/HowItWorks"

function Farming() {
  return (
    <HowItWorks/>
  )
}

export default Farming